import Icons from '@/shared/components/icon/Icons'
import { Text } from '@/shared/components/typography'

type HeaderProps = {
  title: string
  onBackClick: () => void
  onShareClick: () => void
}

const Header = ({ title, onBackClick, onShareClick }: HeaderProps) => (
  <div className="fixed left-[50%] right-0 top-0 z-20 flex w-screen max-w-[768px] translate-x-[-50%] flex-col items-center ">
    <div className="flex h-[56px] w-full items-center bg-main-050 px-4">
      <button type="button" className="mr-2" onClick={onBackClick}>
        <Icons.BackIcon stroke="white" />
      </button>
      <Text level="text3" color="white">
        {title}
      </Text>

      <button type="button" onClick={onShareClick} className="ml-auto h-[24px] w-[24px]">
        <Icons.ShareIcon fill="white" />
      </button>
    </div>
  </div>
)

export default Header
